import '../App.css';

export default function AlertsList({ alerts }) {
  if (!alerts || alerts.length === 0) {
    return (
      <div className="alerts-card glass">
        <p className="eyebrow">Fault alerts</p>
        <p className="muted">No alerts found.</p>
      </div>
    );
  }

  const severityLabel = (alert) => {
    const level = Number(alert.fault_level);
    if (level === 1) return 'critical';
    if (level === 2) return 'warning';
    return 'info';
  };

  return (
    <div className="alerts-card glass">
      <p className="eyebrow">Fault alerts</p>
      <div className="alerts-list">
        {alerts.map((alert) => (
          <div key={alert.fault_code || `${alert.title}-${alert.timestamp || alert.message}`} className="alert-row">
            <div>
              <strong>{alert.fault_name || alert.title}</strong>
              <p className="muted">
                {alert.ps_name ? `${alert.ps_name} - ` : ''}
                {alert.device_name ? `${alert.device_name} - ` : ''}
                {alert.create_time || alert.timestamp || alert.message || '-'}
              </p>
            </div>
            <span className={`badge ${severityLabel(alert)}`}>{severityLabel(alert)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
